import { findParentElement } from "src/standard/ts/findParentElement";
import invariant from "tiny-invariant";

export function findPreviousElement(element: HTMLElement, selector: string) {
  const matchingElements = Array.from(document.querySelectorAll(selector));

  const thisEl = findParentElement(element, selector);
  if (!thisEl) {
    // not found
    return undefined;
  }

  const index = matchingElements.indexOf(thisEl);
  invariant(index > -1);

  return matchingElements[index - 1] as HTMLElement;
}
